import api from './axiosApi'

// Types for name validation API
export interface NameValidationRequest {
  name: string
  exclude_plan_id?: string | null
}

export interface NameValidationResponse {
  is_valid: boolean
  name: string
  error_code: string | null
  error_message: string | null
}

/**
 * Validate a plan name via the API
 * @param name - The plan name to validate
 * @param excludePlanId - Optional plan ID to exclude from duplicate check (for updates)
 */
export async function validatePlanName(
  name: string,
  excludePlanId?: string
): Promise<NameValidationResponse> {
  const trimmedName = name.trim()

  // Client-side empty check for better UX
  if (!trimmedName) {
    return {
      is_valid: false,
      name: trimmedName,
      error_code: 'EMPTY_NAME',
      error_message: 'Plan name cannot be empty.',
    }
  }

  const payload: NameValidationRequest = { name: trimmedName }
  if (excludePlanId) {
    payload.exclude_plan_id = excludePlanId
  }

  const response = await api.post<NameValidationResponse>(
    '/plans/name-validations',
    payload
  )
  return response.data
}
